export const localeToCurrencyCode: {[locale: string]: string} = {
    'fr-FR': "EUR",
    'fr-FR-CSE': "EUR",
    'nl-NL': "EUR",
    'en-US': "GBP",
}